<template>
  <div>
    <div :class="$style['page-end']">
      <BaseIconLink
        type="backlink"
        :href="backLink"
        :class="$style['help-back']"
        @click.native="goBack"
      >
        {{ $t('help.back') }}
      </BaseIconLink>
      <BaseButton
        small
        outlined
        type="secondary"
        :class="$style['open-help-form']"
        @click.native="switchFormState"
        >{{ $t('help.openForm') }}</BaseButton
      >
    </div>
    <HelpForm v-model="isActive" @switchFormState="switchFormState" @submitForm="submitForm" />
    <Snackbar
      :status="status.code"
      :message="status.message"
      :timeout="timeout"
      :show-snackbar="showSnackbar"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'

import HelpForm from './HelpForm.vue'
import Snackbar from '@/js/components/Shared/Snackbar.vue'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_CONSTANTS from '@/js/plugins/store/modules/app/constants.js'
import APP_MUTATIONS from '@/js/plugins/store/modules/app/mutation-types.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'

export default {
  name: 'BuHelpForm',
  components: {
    HelpForm,
    Snackbar,
  },
  data() {
    return {
      isActive: false,
      status: {},
      showSnackbar: false,
      timeout: 5000,
    }
  },
  computed: {
    ...mapState(STOREMODULES.APP, {
      storePath: APP_CONSTANTS.HELP_PATH,
    }),
    ...mapGetters(STOREMODULES.APP, {
      getLinkByType: APP_GETTER.APP_CONFIG_LINK_BY_TYPE,
    }),
    backLink() {
      return this.getLinkByType('help')
    },
  },
  methods: {
    ...mapMutations(STOREMODULES.APP, {
      setStorePath: APP_MUTATIONS.SET_HELP_PATH,
      setReturnFromHelp: APP_MUTATIONS.SET_RETURN_FROM_HELP,
    }),
    switchFormState() {
      this.isActive = !this.isActive
    },
    submitForm(requestData = false) {
      this.isActive = false

      if (requestData) {
        this.status = requestData.status
        this.showSnackbar = requestData.showSnackbar

        this.resetSnackbar()
      }
    },
    goBack() {
      this.setReturnFromHelp(true)
      this.setStorePath(this.storePath.slice(0, -1))
    },
    resetSnackbar() {
      setTimeout(() => {
        this.showSnackbar = false
      }, this.timeout)
    },
  },
}
</script>

<style lang="scss" module>
.page-end {
  @media screen and (min-width: map-get($grid-breakpoints, 'sm')) {
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  display: flex;
  flex-wrap: wrap-reverse;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
}

:global(.content--additional-help-space) {
  margin-bottom: 10rem;
}

.open-help-form {
  @media screen and (min-width: map-get($grid-breakpoints, 'sm')) {
    width: auto;
    padding: 1.4rem !important;

    font-size: inherit !important;
  }
  width: 100%;
  padding: 1.5rem !important;

  font-size: 1rem !important;
}

.help-back {
  @media screen and (min-width: map-get($grid-breakpoints, 'sm')) {
    justify-content: space-between;
    width: auto;
    margin-top: 0 !important;
    padding: 0;

    color: var(--primary) !important;
    font-size: inherit;

    background: none;
    border-radius: none;
  }
  justify-content: center;
  width: 100%;
  margin-top: 0.8rem !important;
  padding: 0.8rem;

  color: var(--white) !important;
  font-size: var(--font-lg);

  background: var(--primary);
  border-radius: 50px;
}
</style>
